import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

const H1 = ({ text, id, className }) => (
  <h1 className={classNames('heading-1 margin-b-primary', className)} id={id}>
    {text}
  </h1>
)

H1.defaultProps = {
  className: 'text-black-base',
}

H1.propTypes = {
  text: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  className: PropTypes.string,
}

export default H1
